export default __webpack_public_path__ + "static/media/left-arrow.e147fa7b.svg";